export default "__VITE_ASSET__CkIuZBtn__"